'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgCalendar(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 2.60077V2.43667C4 2.06848 4.29848 1.77 4.66667 1.77C5.03486 1.77 5.33333 2.06848 5.33333 2.43667V2.60077H10.6667V2.43667C10.6667 2.06848 10.9651 1.77 11.3333 1.77C11.7015 1.77 12 2.06848 12 2.43667V2.60077H12.6667C13.401 2.60077 14 3.1813 14 3.89308V12.9392C14 13.651 13.401 14.2315 12.6667 14.2315H3.33333C2.59896 14.2315 2 13.651 2 12.9392V3.89308C2 3.1813 2.59896 2.60077 3.33333 2.60077H4ZM13.0769 4.0777H2.92308V5.92385H13.0769V4.0777ZM12 9H9V12H12V9Z", fill: "#031B4A" })));
}

module.exports = SvgCalendar;
//# sourceMappingURL=Calendar.js.map
